import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const HYDRA_URL = getBaseUrl('/hydra/');

export async function getDashboard() {
    return await appRequest.doGetRequest(`${HYDRA_URL}/dashboard`);
}
